import { motion } from "framer-motion";
import { Wifi, PhoneCall, MessageCircleMore } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" className="bg-hero-gradient">
      <div className="container-max grid md:grid-cols-2 gap-8 items-center py-12 md:py-16 lg:py-24">
        <div>
          <div className="inline-flex items-center gap-2 mb-3 sm:mb-2">
            <span className="inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-green-400 via-blue-500 to-orange-400 text-white px-3 py-1 text-[10px] sm:text-xs font-bold tracking-widest">
              5G
            </span>
            <span className="text-[10px] sm:text-[11px] uppercase tracking-wider text-brand-blue/60">Broadband Broad Network</span>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-3 sm:mb-2 text-xs sm:text-sm font-semibold tracking-wider text-brand-blue/70 uppercase"
          >
            Broadband Broad Network 5G
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-brand-blue mb-3 sm:mb-4 leading-tight"
          >
            No Internet No Cost
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="text-sm sm:text-base md:text-lg text-brand-blue/80 leading-relaxed"
          >
            Pay only for active internet usage. Reliable speeds, transparent pricing, and friendly local support.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-6 flex flex-col sm:flex-row gap-3"
          >
            <a href="#plans" className="btn btn-primary text-center">View Plans</a>
            <a href="tel:+919712877584" className="btn btn-outline gap-2 justify-center">
              <PhoneCall size={18} /> +91 97128 77584
            </a>
          </motion.div>

          <div className="mt-6 space-y-3">
            <div className="inline-flex items-center gap-2 rounded-lg border border-brand-blue/20 bg-white/80 px-4 py-3 text-sm font-semibold">
              <PhoneCall size={16} className="text-brand-orange" />
              <span>Call us: +91 97128 77584</span>
            </div>
            <a href="https://wa.me/918155977584" className="inline-flex items-center gap-2 rounded-lg border border-green-100 bg-green-50 px-4 py-3 text-sm font-semibold hover:bg-green-100 transition-colors">
              <MessageCircleMore size={16} className="text-green-600" />
              <span>WhatsApp: +91 81559 77584</span>
            </a>
            <div className="inline-flex items-center gap-2 rounded-lg border border-brand-blue/20 bg-white/80 px-3 py-2 text-sm">
              <span className="inline-block h-2 w-2 rounded-full bg-green-500 animate-pulse" />
              Refund Policy Available
            </div>
          </div>
        </div>

        <div className="relative flex justify-center md:justify-end order-first md:order-last">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="relative z-10 card p-6 sm:p-8 md:p-10 w-full max-w-sm mx-auto"
          >
            <div className="mx-auto flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full bg-[color:var(--brand-orange)]/10 text-[color:var(--brand-orange)]">
              <Wifi size={36} className="sm:size-44" />
            </div>
            <p className="mt-3 sm:mt-4 text-center text-xs sm:text-sm text-brand-blue/70">Fast, stable, and secure connectivity</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="absolute -inset-4 sm:-inset-6 md:-inset-10 -z-0 rounded-3xl bg-gradient-to-tr from-brand.orange.light/40 to-white"
          />

          {/* WiFi waves - simplified for mobile */}
          <div className="absolute inset-0 flex items-center justify-end pr-4 sm:pr-6 md:pr-10">
            <div className="relative">
              <div className="absolute left-1/2 top-1/2 h-20 w-20 sm:h-28 sm:w-28 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[color:var(--brand-orange)]/30 [animation:wave_2.2s_ease-out_infinite]" />
              <div className="absolute left-1/2 top-1/2 h-32 w-32 sm:h-40 sm:w-40 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[color:var(--brand-orange)]/20 [animation:wave_2.6s_ease-out_infinite]" style={{ animationDelay: '0.3s' }} />
              <div className="hidden sm:block absolute left-1/2 top-1/2 h-56 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-[color:var(--brand-orange)]/10 [animation:wave_3s_ease-out_infinite]" style={{ animationDelay: '0.6s' }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
